"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.similarAthletesDummyData = {
    athletes: [{
            url: '/event/3294/results/Event/649987/Course/1157480/bib/4155',
            useLink: false,
            racerId: '326537687',
            keycloakId: '123124',
            photos: '/aws/racer/t/326537687/',
            displayName: 'Vladimir Figari Testino',
            ageOnRaceDay: 47,
            location: {
                city: 'Lima',
                region: 'Lima',
                country: 'PE'
            },
            gender: 'male',
            bib: '4155',
            claimed: true,
            isFriend: false,
            profilePicUrl: '/aws/racer/t/326537687/',
            showAthletePhoto: true,
            showGender: true
        },
        {
            url: '/event/3294/results/Event/649987/Course/1157481/bib/20177',
            useLink: false,
            racerId: '370377553',
            keycloakId: '123124',
            photos: '/aws/racer/t/370377553/',
            displayName: 'Cristian Melendez Collazo',
            ageOnRaceDay: 22,
            location: {
                city: 'Orocovis',
                region: 'PR',
                country: 'US'
            },
            gender: 'male',
            bib: '20177',
            claimed: true,
            isFriend: false,
            profilePicUrl: '/aws/racer/t/370377553/',
            showAthletePhoto: true,
            showGender: true
        },
        {
            url: '/event/3294/results/Event/649987/Course/1157481/bib/22591',
            useLink: false,
            racerId: '370378493',
            keycloakId: '123124',
            photos: '/aws/racer/t/370378493/',
            displayName: 'Nicolas Santos',
            ageOnRaceDay: 40,
            location: {
                city: 'Bogota',
                region: 'Distritio Capital de Bogotá',
                country: 'CO'
            },
            gender: 'male',
            bib: '22591',
            claimed: true,
            isFriend: false,
            profilePicUrl: '/aws/racer/t/370378493/',
            showAthletePhoto: true,
            showGender: true
        },
        {
            url: '/event/3294/results/Event/649987/Course/1157481/bib/20388',
            useLink: false,
            racerId: '249265207',
            keycloakId: '123124',
            photos: '/aws/racer/t/249265207/',
            displayName: 'Dmytro Molchanov',
            ageOnRaceDay: 19,
            location: {
                city: 'Brooklyn',
                region: 'NY',
                country: 'US'
            },
            gender: 'male',
            bib: '20388',
            claimed: true,
            isFriend: false,
            profilePicUrl: '/aws/racer/t/249265207/',
            showAthletePhoto: true,
            showGender: true
        }
    ]
};
//# sourceMappingURL=SimilarAthletesDummyData.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlete-api-client/dist/data/SimilarAthletesDummyData.js
 ** module id = 2067
 ** module chunks = 0
 **/